import formFieldNames from '../constants/formFieldNames';
import passengers from '../constants/passengers';
import { getSingleBound } from './options';

export const searchForm = {
  formFieldNames,
  getSingleBound,
  ...passengers,
};
